import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export const RedirectToLocation: React.FC = () => {

    const navigate = useNavigate()

    useEffect(() => {
        navigate("/analytics")
    }, [navigate]);

    return <></>
}
